import cc from "@/assets/images/modes-commande/cc.svg";
import cev from "@/assets/images/modes-commande/cev.svg";
import drive from "@/assets/images/modes-commande/drive.svg";
import lad from "@/assets/images/modes-commande/lad.svg";
import lc from "@/assets/images/modes-commande/lc.svg";
import prc from "@/assets/images/modes-commande/prc.svg";
import prp from "@/assets/images/modes-commande/prp.svg";
import prc_delipop from "@/assets/images/modes-commande/prc_delipop.svg"

export const modesCommande = {
  cc,
  cev,
  drive,
  lad,
  lc,
  prc,
  prp,
  prc_delipop
}
